var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-blue[data-v-69ec0dbc]{color:#42a3f7}.h-70px[data-v-69ec0dbc]{height:70px!important}.login-title[data-v-69ec0dbc]{font-weight:700;text-transform:capitalize;color:#464646}.backgroundDiv[data-v-69ec0dbc]{background-image:url(" + escape(require("../../assets/images/backend1.png")) + ");height:100%;background-size:cover}.captchaImg[data-v-69ec0dbc]{border:1px solid #eee;cursor:pointer;width:100%}.flex-center[data-v-69ec0dbc]{display:flex;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69ec0dbc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/authorization/Login.vue
// module id = 805
// module chunks = 0